var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("p", { class: { mb: _vm.marginBottom, ml: _vm.marginLeft } }, [
    _c("b", { class: _vm.blackLabel ? "blackLabel" : "" }, [
      _vm._v(_vm._s(_vm.label))
    ]),
    _vm.isContentInNextLine ? _c("br") : _vm._e(),
    _vm.textIcon !== ""
      ? _c(
          "span",
          [
            _c(
              "el-tooltip",
              {
                staticClass: "item",
                attrs: {
                  effect: "dark",
                  content: _vm.textIcon,
                  placement: _vm.toolTip
                }
              },
              [
                _c("span", {
                  attrs: { slot: "content" },
                  domProps: { innerHTML: _vm._s(_vm.textIcon) },
                  slot: "content"
                }),
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: "info-circle", size: "1x" }
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm.content && !_vm.isContentInNextLine
      ? _c(
          "span",
          {
            staticClass: "text",
            class: { "float-right": _vm.contentAlignRight }
          },
          [_vm._v("   " + _vm._s(_vm.formataContent(_vm.content)))]
        )
      : _vm._e(),
    _vm.content && _vm.isContentInNextLine
      ? _c("span", {
          staticClass: "text",
          class: { "float-right": _vm.contentAlignRight },
          domProps: { innerHTML: _vm._s(_vm.formataContent(_vm.content)) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a4f7dde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a4f7dde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDisplay.vue
// module id = null
// module chunks = 